<svg width="17" height="7" viewBox="0 0 17 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.186646" width="16.1622" height="2.2" rx="1.1" fill="currentColor"/>
<rect x="0.5" y="5.18665" width="16.1622" height="1" rx="0.5" fill="currentColor"/>
</svg>
